var _excluded = ["className", "loadImmediately"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { jsx as ___EmotionJSX } from "@emotion/core";
class AllhomesLazyLoadedContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false
    };
    this.load = this.load.bind(this);
  }
  load() {
    if (!this.state.loaded) {
      this.setState({
        loaded: true
      });
    }
  }
  render() {
    var _this$props = this.props,
      className = _this$props.className,
      loadImmediately = _this$props.loadImmediately,
      otherProps = _objectWithoutProperties(_this$props, _excluded);
    return ___EmotionJSX("div", _extends({
      className: classnames(className, {
        'is-loaded': this.state.loaded
      })
    }, otherProps), this.state.loaded || this.props.loadImmediately ? this.props.children : []);
  }
}
AllhomesLazyLoadedContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.element.isRequired,
  loadImmediately: PropTypes.bool
};
AllhomesLazyLoadedContainer.defaultProps = {
  className: 'fe-co-allhomes-lazy-loaded-container',
  loadImmediately: false
};
export default AllhomesLazyLoadedContainer;